export default "__VITE_ASSET__Bi0wwNZy__"